import comp from "./NoTabFocusWrapper";
export default comp;
